import { render, staticRenderFns } from "./cooperationList.vue?vue&type=template&id=0984ec36&scoped=true"
import script from "./cooperationList.vue?vue&type=script&lang=js"
export * from "./cooperationList.vue?vue&type=script&lang=js"
import style0 from "./cooperationList.vue?vue&type=style&index=0&id=0984ec36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984ec36",
  null
  
)

export default component.exports